<template>
  <div>
    <ChengkuangPayableList v-if="userInfo.businessGroup == '城矿'"></ChengkuangPayableList>
    <PayableList v-else></PayableList>
  </div>
</template>

<script>
  import ChengkuangPayableList from './payableStatementList/chengkuangPayableList/index.vue';
  import PayableList from './payableStatementList/index.vue';
  export default {
    name: 'payableList',
    components: { ChengkuangPayableList, PayableList },
  };
</script>

<style></style>
